export const endpointsToExcludeTheJWT = [
  "auth/login/",
  "auth/register/",
  "auth/forget_password/",
  "auth/reset_password/",
  "auth/token/refresh/",
  "shop_login/",
];
